module.exports = __webpack_public_path__ + "img/SkeletonScreen.36ee9225.jpg";